import { ChangeDetectionStrategy, Component, Inject } from '@angular/core'
import { ComponentPortal, TemplatePortal } from '@angular/cdk/portal'
import { combineLatest, Observable } from 'rxjs'
import { map } from 'rxjs/operators'
import { RxStateComponent } from '@alliance/shared/models'
import { MediaService, UserSideEnum } from '@alliance/shared/utils'
import { HEADER_BOTTOM_CONTENT, HeaderData, HeaderHelperService } from '@alliance/shared/header/utils'

@Component({
  selector: 'lib-lazy-header',
  templateUrl: './lazy-header.component.html',
  styleUrls: ['./lazy-header.component.tw.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LazyHeaderComponent extends RxStateComponent<{
  isMobileScreen: boolean
  headerData: HeaderData | null
  isShowHeader: boolean
  bottomContent: ComponentPortal<unknown> | TemplatePortal<unknown> | null
}> {
  public readonly UserSideEnum = UserSideEnum

  public readonly state = this.connectViewState(['headerData', 'isShowHeader', 'bottomContent'])

  public constructor(
    private mediaService: MediaService,
    public headerHelperService: HeaderHelperService,
    @Inject(HEADER_BOTTOM_CONTENT) public headerBottomContent$: Observable<ComponentPortal<unknown>>
  ) {
    super()

    this.initState({
      headerData: null,
      isMobileScreen: this.mediaService.select('isMobileScreen'),
      isShowHeader: combineLatest([this.select('headerData'), this.select('isMobileScreen')]).pipe(
        map(([data, isMobileScreen]) => !!(data?.preventRenderHeaderIfMobile ? !isMobileScreen && data?.isShowHeader : data?.isShowHeader))
      ),
      bottomContent: this.headerBottomContent$
    })
  }
}
